const routes = [
    {
        path: "/esl/student/module/statuses",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "studentmodulestatus_index"
        }
    }
];

export default routes;
